import script from "./InsertCpf.vue?vue&type=script&setup=true&lang=js"
export * from "./InsertCpf.vue?vue&type=script&setup=true&lang=js"

import "./InsertCpf.vue?vue&type=style&index=0&id=1645ed60&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1645ed60"]])

export default __exports__